import React from "react";
import { useLocation, useNavigate } from "react-router-dom"
import _ from "lodash"
import {
    useDownloadRegistrationPdfMutation
} from "../Redux/actions/download.action"
import { Loader } from "../components/index"
import { toaster, Message } from "rsuite";

export default function DownloadRegistrationReciept() {
    const location = useLocation()
    const navigate = useNavigate()

    const [downloadPdfAction, downloadPdfState] = useDownloadRegistrationPdfMutation()

    React.useEffect(() => {
        if (downloadPdfState.isSuccess) {
            try {
                const blob = _.get(downloadPdfState, "data", null)
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = url
                a.download = "Registration.pdf"
                document.body.appendChild(a)
                a.click()
                downloadPdfState.reset()
            } catch (error) {
                downloadPdfState.reset()
            }
        }
        if (downloadPdfState.isError) {
            toaster.push(<Message type="error" >Something went wrong!while download response.</Message>, { placement: "topCenter" })
            downloadPdfState.reset()
        }
    }, [downloadPdfState.status])

    const data = location.state?.data

    // If user refreshes page or direct access
    if (!data) {
        return (
            <div style={{ textAlign: "center", marginTop: 40 }}>
                <h3>⚠️ No registration data found</h3>
                <button onClick={() => navigate("/")}>
                    Go Back
                </button>
            </div>
        )
    }
    const photoUrl = _.get(data, "meta_data.photo", null) ? JSON.parse(_.get(data, "meta_data.photo"))?.url : ""
    const dobUrl = _.get(data, "meta_data.dobCerfiticate", null) ? JSON.parse(_.get(data, "meta_data.dobCerfiticate", null)).url : ""
    return (
        <div style={styles.container}>
            <h2 style={styles.header}>🎉 Thanks for Registration</h2>

            <div style={styles.photoWrapper}>
                <img src={photoUrl} alt="Student" style={styles.photo} />
            </div>
            {
                dobUrl && (
                    <div style={{
                        width: "100%",
                        height: "300px",
                        overflowY: "scroll"
                    }}>
                        <img src={dobUrl} alt="Student" style={{
                            width:"auto",
                            height:"auto"
                        }} />
                    </div>
                )
            }
            <div style={styles.card}>
                <Detail label="First Name" value={data.firstname} />
                <Detail label="Last Name" value={data.lastname} />
                <Detail label="Father Name" value={data.fathername} />
                <Detail label="Mother Name" value={data.mothername} />
                <Detail label="Contact Number" value={data.pnumber} />
                <Detail label="Email" value={data.email} />
                <Detail label="Father Occupation" value={data.fatherOccupation} />
                <Detail label="Mother Occupation" value={data.motherOccupation} />
                <Detail label="Date of Birth" value={data.age} />
                <Detail label="Gender" value={data.gender} />
                <Detail label="Last Examination" value={data.lastExamination} />
                <Detail label="Year" value={data.year} />
                <Detail label="Division" value={data.division} />
                <Detail label="Marks Obtained" value={data.markObtain} />
                <Detail label="Registration ID" value={data.id} />
            </div>

            <div style={styles.download}>
                <a
                    href={data.dobCerfiticate}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                    onClick={() => {
                        const datainfo = {
                            "firstname":_.get(data,"firstname",""),
                            "lastname":_.get(data,"lastname",""),
                            "fathername":_.get(data,"fathername",""),
                            "mothername":_.get(data,"mothername",""),
                            "cnumber":_.get(data,"cnumber",""),
                            "pnumber":_.get(data,"pnumber",""),
                            "email":_.get(data,"email",""),
                            "fatherOccupation":_.get(data,"fatherOccupation",""),
                            "motherOccupation":_.get(data,"motherOccupation",""),
                            "dob":_.get(data,"age",""),
                            "gender":_.get(data,"gender",""),
                            "lastExamination":_.get(data,"lastExamination",""),
                            "year":_.get(data,"year",""),
                            "division":_.get(data,"division",""),
                            "markObtain":_.get(data,"markObtain",""),
                            "id":_.get(data,"id",1),
                            "photo":photoUrl,
                            "dobCerfiticate":dobUrl
                        }
                        downloadPdfAction(datainfo)
                    }}
                >
                    ⬇️ Download
                </a>
            </div>
            {
                downloadPdfState.isSuccess && (
                    <Loader show={true} />
                )
            }
        </div>
    );
}

const Detail = ({ label, value }) => (
    <div style={styles.row}>
        <span style={styles.label}>{label}</span>
        <span style={styles.value}>{value || "—"}</span>
    </div>
);

const styles = {
    container: {
        maxWidth: 600,
        margin: "40px auto",
        padding: 20,
        background: "#fff",
        borderRadius: 8,
        fontFamily: "Arial, sans-serif",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    },
    header: {
        textAlign: "center",
        marginBottom: 20,
    },
    photoWrapper: {
        textAlign: "center",
        marginBottom: 20,
    },
    photo: {
        width: 120,
        height: 120,
        borderRadius: "50%",
        objectFit: "cover",
    },
    card: {
        borderTop: "1px solid #eee",
        paddingTop: 10,
    },
    row: {
        display: "flex",
        justifyContent: "space-between",
        padding: "8px 0",
        borderBottom: "1px solid #f3f3f3",
    },
    label: {
        fontWeight: 600,
    },
    value: {
        color: "#333",
    },
    download: {
        textAlign: "center",
        marginTop: 20,
    },
};
